export const GLYPH_VIEWBOX = '0 0 16 16';
export const GLYPH_STROKE = 1.5;
export const GLYPHS = {
    // A heater shield with a rank chevron.
    pc: [
        'M2.75 2.75 H13.25 V7.25 C13.25 10.5 11 12.75 8 14.25 C5 12.75 2.75 10.5 2.75 7.25 Z',
        'M5.5 6.25 L8 8.75 L10.5 6.25',
    ],
    // A bust: head and shoulders.
    npc: [
        'M5.5 5.25 A2.5 2.5 0 1 0 10.5 5.25 A2.5 2.5 0 1 0 5.5 5.25 Z',
        'M2.75 14.25 C2.75 11 5 9.25 8 9.25 C11 9.25 13.25 11 13.25 14.25',
    ],
    // Three claw slashes.
    creature: [
        'M3.25 13 C3.25 9 4.75 5.5 7.25 2.75',
        'M6.75 13.75 C6.75 9.75 8.25 6.25 10.75 3.5',
        'M10.25 13 C10.25 10 11.25 7.5 13 5.25',
    ],
    // Crossed swords.
    encounter: [
        'M2.75 2.75 L9.5 9.5',
        'M8.25 10.75 L10.75 8.25',
        'M9.5 9.5 L13 13',
        'M13.25 2.75 L6.5 9.5',
        'M5.25 8.25 L7.75 10.75',
        'M6.5 9.5 L3 13',
    ],
    // A map pin.
    location: [
        'M8 14.25 C5.5 11.5 3.25 8.75 3.25 6.25 A4.75 4.75 0 0 1 12.75 6.25 C12.75 8.75 10.5 11.5 8 14.25 Z',
        'M6.5 6.25 A1.5 1.5 0 1 0 9.5 6.25 A1.5 1.5 0 1 0 6.5 6.25 Z',
    ],
    // A swallow-tailed pennant on a pole.
    faction: ['M3.5 14.25 V1.75', 'M3.5 2.5 H12.75 L10.5 5.25 L12.75 8 H3.5'],
    // A flask with a liquid line.
    item: [
        'M6 1.75 H10',
        'M6.75 1.75 V5.5 L3.25 11.75 C2.75 12.75 3.5 14.25 4.75 14.25 H11.25 C12.5 14.25 13.25 12.75 12.75 11.75 L9.25 5.5 V1.75',
        'M4.75 9.75 H11.25',
    ],
    // An open book.
    lore: [
        'M8 4.25 C6.5 3 4.5 2.75 2 3 V12.5 C4.5 12.25 6.5 12.5 8 13.75 C9.5 12.5 11.5 12.25 14 12.5 V3 C11.5 2.75 9.5 3 8 4.25 Z',
        'M8 4.25 V13.75',
    ],
    // A rising and falling story line, ending in an arrow.
    arc: [
        'M2 13.25 C3.75 6 6 3.75 8 3.75 C10 3.75 12.25 6 14 13.25',
        'M11.25 11.5 L14 13.25 L14.75 10.25',
    ],
    // A dotted path ending in an X.
    quest: [
        'M2.25 13.75 L2.25 13.75',
        'M4.75 12.75 L4.75 12.75',
        'M6.75 11 L6.75 11',
        'M8.25 8.75 L8.25 8.75',
        'M10.25 3.25 L13.25 6.25',
        'M13.25 3.25 L10.25 6.25',
    ],
    // Two speech bubbles.
    script: [
        'M2 2.5 H9.5 V7.75 H5.5 L3.25 9.75 V7.75 H2 Z',
        'M11.5 5.75 H14 V11.25 H12.75 V13.25 L10.5 11.25 H6.5 V9.75',
    ],
    // A twenty-sided die.
    session: [
        'M8 1.75 L13.25 4.75 V11.25 L8 14.25 L2.75 11.25 V4.75 Z',
        'M8 5 L11.25 10.5 H4.75 Z',
        'M8 1.75 V5',
        'M2.75 11.25 L4.75 10.5',
        'M13.25 11.25 L11.25 10.5',
    ],
    // A wand with a sparkle.
    spell: [
        'M2.75 13.25 L9.25 6.75',
        'M11.75 1.75 V5.25',
        'M10 3.5 H13.5',
        'M13.25 8.25 L13.25 8.25',
    ],
    // A page with a folded corner.
    note: [
        'M3.25 1.75 H9.5 L12.75 5 V14.25 H3.25 Z',
        'M9.5 1.75 V5 H12.75',
        'M5.5 8.25 H10.5',
        'M5.5 11 H10.5',
    ],
    // A radiant disc: a halo ringed by eight rays.
    deity: [
        'M5.5 8 A2.5 2.5 0 1 0 10.5 8 A2.5 2.5 0 1 0 5.5 8 Z',
        'M8 1.75 V3.75',
        'M8 12.25 V14.25',
        'M1.75 8 H3.75',
        'M12.25 8 H14.25',
        'M3.5 3.5 L4.75 4.75',
        'M12.5 3.5 L11.25 4.75',
        'M3.5 12.5 L4.75 11.25',
        'M12.5 12.5 L11.25 11.25',
    ],
};
/** A readable name per type, for labels and chips ("NPC", "Quest"). */
export const TYPE_LABELS = {
    pc: 'PC',
    npc: 'NPC',
    creature: 'Creature',
    encounter: 'Encounter',
    location: 'Location',
    faction: 'Faction',
    item: 'Item',
    lore: 'Lore',
    arc: 'Arc',
    quest: 'Quest',
    script: 'Script',
    session: 'Session',
    spell: 'Spell',
    note: 'Note',
    deity: 'Deity',
};
/** Plural labels for the sidebar ("NPCs", "Lore"). */
export const TYPE_PLURALS = {
    pc: 'PCs',
    npc: 'NPCs',
    creature: 'Creatures',
    encounter: 'Encounters',
    location: 'Locations',
    faction: 'Factions',
    item: 'Items',
    lore: 'Lore',
    arc: 'Arcs',
    quest: 'Quests',
    script: 'Scripts',
    session: 'Sessions',
    spell: 'Spells',
    note: 'Notes',
    deity: 'Deities',
};
//# sourceMappingURL=paths.js.map